import styled from 'styled-components';

export const ButtonArea = styled.div`
  display: flex;
  align-items: center;
  margin-left: -5px;
  margin-bottom: 1rem;
`;
